import React from 'react'
import { Grid, TextField, Select, MenuItem,
    FormControl, InputLabel} from '@mui/material'
// import { useNavigate } from 'react-router-dom';
// import { useState } from 'react';
import WorkverificationParts from './WorkVerificationParts';
import WorkverificationTask from './WorkverificationTask';
import HeaderBox from '../HeaderBox';
import Box from '@mui/material/Box';
import DateCalander from '../DateCalander';
// import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
// import { borders } from '@mui/system';

// const commonStyles = {
//   bgcolor: 'background.paper',
//   m: 1,
//   border: 1,
//   width: '5rem',
//   height: '5rem',
// };

const dataGridStyle = {
  root: {
    "& .MuiDataGrid-root": {
      borderRadius: '10px',
      backgroundColor: 'white',
      fontSize: '15px',
    },
    "& .MuiDataGrid-columnHeaders": {
      color: '#005A9C',
      fontSize: '16px',
    }
  },
};
const boxStyle = {
  root: {
    backgroundColor: 'white', 
    borderRadius: '5px',
    padding: 1
  },
};

function WorkVerification() {
  // const navigate = useNavigate()
  // const [isParts, setIsParts] = useState(false)
  return (
    <Box sx={dataGridStyle.root}>
      <Grid container spacing={1}>
        <Grid item xs={12} >
        <Box>
          <form>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={boxStyle.root} >
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6} md={2} >
                        <FormControl fullWidth size="small" required  >
                        <InputLabel id="demo-simple-select-label"> Verifyed By</InputLabel>
                        <Select labelId="demo-simple-select-label" id="demo-simple-select" label="Verifyed By*">
                            <MenuItem value={10}> Advisor </MenuItem>
                            <MenuItem value={20}>Supervisor</MenuItem>
                        </Select>
                    </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2} >
                        <DateCalander  title='Closing Date'/>
                        </Grid>
                    </Grid>
                </Box>
              </Grid>
                <Grid item xs={12} >
                    <HeaderBox title="Task" />
                    <WorkverificationTask/>
                </Grid>
                <Grid item xs={12} >
                    <HeaderBox title="Spare Parts" />
                    <WorkverificationParts/>
                </Grid>
                
              <Grid item xs={12} sm={5} >
                    <TextField fullWidth size='small' label= 'Suggestion To Mechanic' variant="outlined"required name='Suggestion To Mechanic'  inputProps={{style: {height: '180px'}}} multiline/>
                </Grid> 
                <Grid item xs={12} sm={5}>
                    <TextField fullWidth size='small' label= 'Feedback From Mechanic' variant="outlined"required name='Feedback From Mechanic' inputProps={{style: {height: '180px'}}}  multiline/>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <HeaderBox title="Expected Invoice Value" />
                    <Box sx= {{border:'1px solid'}}  padding={1}> 
                    <Grid container spacing={1}>
                        <Grid item xs={12} >
                          <Box borderBottom='1px solid'> <span> Labour </span></Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box borderBottom='1px solid'> <span> Parts </span> </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box borderBottom='1px solid'> <span> Total </span> </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box borderBottom='1px solid'> <span> VAT% </span> </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box borderBottom='1px solid'> <span> Net Amount</span> </Box>
                        </Grid>
                      </Grid>
                    </Box>
                </Grid>
            </Grid> 
          </form>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default WorkVerification